import { render } from "./EmbargosGobernacion.vue?vue&type=template&id=49d21da7&scoped=true"
import script from "./EmbargosGobernacion.vue?vue&type=script&lang=js"
export * from "./EmbargosGobernacion.vue?vue&type=script&lang=js"

import "./EmbargosGobernacion.vue?vue&type=style&index=0&id=49d21da7&scoped=true&lang=css"

import exportComponent from "/var/www/html/tesoreria_tolima/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49d21da7"]])

export default __exports__